export const LANGUAGE = 'language'
export const DEFAULT = 'us'
export const VN = 'vn'
export const US = 'us'